import { computed, ref, unref } from 'vue';
import SalesTransactionPartiesAPI from 'dashboard/api/salesTransactionParties';

const responseData = response => response?.data?.data || [];

export function useSalesParties({ transactionId, role, t, notify }) {
  const parties = ref([]);
  const loading = ref(false);
  const loaded = ref(false);
  const error = ref('');
  const saving = ref(false);

  const load = async () => {
    const id = unref(transactionId);
    if (!id) return [];

    loading.value = true;
    error.value = '';
    try {
      const response = await SalesTransactionPartiesAPI.list(id, {
        party_role: unref(role),
      });
      parties.value = responseData(response);
      return parties.value;
    } catch (requestError) {
      error.value =
        requestError?.response?.data?.message || t('SALES_PARTIES.ERRORS.LOAD');
      notify(error.value);
      return [];
    } finally {
      loading.value = false;
      loaded.value = true;
    }
  };

  const create = async payload => {
    saving.value = true;
    try {
      const response = await SalesTransactionPartiesAPI.create(
        unref(transactionId),
        payload
      );
      const party = response?.data?.data;
      if (party) parties.value = [...parties.value, party];
      return party;
    } catch (requestError) {
      notify(
        requestError?.response?.data?.message || t('SALES_PARTIES.ERRORS.SAVE')
      );
      return null;
    } finally {
      saving.value = false;
    }
  };

  const remove = async party => {
    saving.value = true;
    try {
      await SalesTransactionPartiesAPI.remove(unref(transactionId), party.id);
      parties.value = parties.value.filter(item => item.id !== party.id);
      notify(t('SALES_PARTIES.NOTICES.REMOVED'));
      return true;
    } catch (requestError) {
      notify(
        requestError?.response?.data?.message ||
          t('SALES_PARTIES.ERRORS.REMOVE')
      );
      return false;
    } finally {
      saving.value = false;
    }
  };

  const grouped = computed(() => ({
    people: parties.value.filter(party => party.party_kind === 'pessoa_fisica'),
    companies: parties.value.filter(
      party => party.party_kind === 'pessoa_juridica'
    ),
  }));

  return {
    create,
    error,
    grouped,
    load,
    loaded,
    loading,
    parties,
    remove,
    saving,
  };
}
